import React from 'react';
import { Column } from 'new/elements/Table/types';
import { SourceName } from 'new/elements/SourceName';
import { ChipBadge } from 'new/elements/ChipBadge';
import { DataSource } from 'new/entities/DataSource';

export const columns = [
  {
    name: 'Details',
    field: 'sourceName',
    width: 35,
    renderRow: (row) => {
      return <SourceName title={row.sourceName} type={'source'} icon={row.icon} name={row.name} />;
    },
  },
  {
    name: 'Status',
    field: 'statusInfo.name',
    renderRow: (row) => {
      return (
        <ChipBadge
          dot
          label={row.statusInfo.name}
          // @ts-ignore
          color={row.statusInfo.color}
        />
      );
    },
  },
  {
    name: 'Nexsets',
    field: 'nexsetsCount',
  },
  {
    name: 'Identification',
    field: 'id',
    renderRow: (row) => <ChipBadge color="success" label={row.id + ''} />,
    center: true,
  },
  {
    name: 'Created',
    field: 'createdAt',
  },
] as Column<DataSource>[];
